import React from 'react';

const ErrorPage = (error = '') => {
	return (
		<section>
			<div className="wrapper" style={{ textAlign: "center" }}>
				<h2>Something went wrong.</h2>

				<p>Please try again later.</p>

				{ error.message && <p>{error.message}</p> }
			</div>
		</section>
	);
};

export default ErrorPage;